import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Typography } from '../../../designComponents';
import { BUILDING_ROUTE } from '../../../routes/routePaths';
import {
  InfoRowStyled,
  VerticalSpaceStyled,
} from '../../../style/reusableStyle';
import { ButtonEndContainerStyled, JobDetailsContainerStyled } from './style';

type Props = {
  buildingId: string;
  buildingName: string;
  addressOfProperty: string;
};

const PropertyInformation = ({
  addressOfProperty,
  buildingName,
  buildingId,
}: Props) => {
  const navigate = useNavigate();

  const navigateToBuilding = () => {
    navigate(`${BUILDING_ROUTE}/${buildingId}`);
  };

  return (
    <JobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        PROPERTY INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Building Name :</Typography>
          <Typography className="value">{buildingName}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Address of Property :</Typography>
          <Typography className="value">{addressOfProperty}</Typography>
        </InfoRowStyled>

        <ButtonEndContainerStyled>
          <Button variant="primary" size="xs" onClick={navigateToBuilding}>
            View Property
          </Button>
        </ButtonEndContainerStyled>
      </VerticalSpaceStyled>
    </JobDetailsContainerStyled>
  );
};

export default PropertyInformation;
